import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './Header.module.css';

const Header = () => {
  const { user, logout, loading } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogoutLink = async (e) => {
    e.preventDefault();
    setMenuOpen(false);
    await logout();
    navigate('/login');
  };

  const handleMenuToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  const isSeller = ['organizer', 'artist', 'venue'].includes(user?.role);

  if (loading) return null;

  return (
    <header className={styles.header}>
      <div className={styles.logoContainer}>
        <Link to="/" className={styles.logoLink}>
          <img
            src="/icons/irietix.svg"
            alt="IrieTix ロゴ"
            className={styles.logoImage}
          />
        </Link>
      </div>
      <button className={styles.menuButton} onClick={handleMenuToggle} aria-label="メニュー">
        {menuOpen ? '×' : '≡'}
      </button>
      <nav className={`${styles.nav} ${menuOpen ? styles.open : ''}`}>
        {!isSeller && (
          <Link to="/seller-register" className={styles.sell} onClick={() => setMenuOpen(false)}>
            チケット販売はこちら
          </Link>
        )}
        {user ? (
          <>
            {isSeller && (
              <Link to="/dashboard" className={styles.link} onClick={() => setMenuOpen(false)}>
                ダッシュボード
              </Link>
            )}
            <Link to="/profile/my" className={styles.link} onClick={() => setMenuOpen(false)}>
              {isSeller ? 'プロフィール' : 'マイページ'}
            </Link>
            <Link to="/settings/credentials" className={styles.link} onClick={() => setMenuOpen(false)}>
              登録情報変更
            </Link>
            <Link to="/login" onClick={handleLogoutLink} className={styles.logout}>
              ログアウト
            </Link>
          </>
        ) : (
          <Link to="/login" className={styles.link} onClick={() => setMenuOpen(false)}>
            ログイン
          </Link>
        )}
      </nav>
    </header>
  );
};


export default Header;
